import { create } from "zustand";
import { PricingPlan } from "@/api/models/api-types";
import { navigateToPricing, navigateBack } from "@/lib/navigation-service";

interface PricingState {
  // State
  selectedPlan: PricingPlan | null;
  selectedBillingCycle: "monthly" | "yearly" | "one-time";

  // Actions
  setSelectedPlan: (plan: PricingPlan | null) => void;
  setSelectedBillingCycle: (cycle: "monthly" | "yearly" | "one-time") => void;
  openPricingModal: () => void;
  openPricingModalWithTopup: () => void;
  closePricingModal: () => void;
  resetPricing: () => void;
}

export const usePricingStore = create<PricingState>((set) => ({
  // Initial state
  selectedPlan: null,
  selectedBillingCycle: "monthly",

  // Actions
  setSelectedPlan: (plan) => set({ selectedPlan: plan }),
  setSelectedBillingCycle: (cycle) => set({ selectedBillingCycle: cycle }),
  openPricingModal: () => {
    set({ selectedBillingCycle: "monthly" });
    navigateToPricing("monthly");
  },
  openPricingModalWithTopup: () => {
    set({ selectedBillingCycle: "one-time" });
    navigateToPricing("one-time");
  },
  closePricingModal: () => {
    navigateBack();
  },
  resetPricing: () =>
    set({
      selectedPlan: null,
      selectedBillingCycle: "monthly",
    }),
}));
